__turbopack_context__.v({
  "detailsContainer": "ImvHTW_detailsContainer",
  "embla": "ImvHTW_embla",
  "emblaButton": "ImvHTW_emblaButton",
  "emblaButtonCarousel": "ImvHTW_emblaButtonCarousel",
  "emblaButtonNext": "ImvHTW_emblaButtonNext",
  "emblaButtonPrev": "ImvHTW_emblaButtonPrev",
  "emblaContainer": "ImvHTW_emblaContainer",
  "emblaContainerCnt": "ImvHTW_emblaContainerCnt",
  "emblaDash": "ImvHTW_emblaDash",
  "emblaDashes": "ImvHTW_emblaDashes",
  "emblaImg": "ImvHTW_emblaImg",
  "emblaSlide": "ImvHTW_emblaSlide",
  "emblaSlideContainer": "ImvHTW_emblaSlideContainer",
  "emblaViewport": "ImvHTW_emblaViewport",
  "followRow": "ImvHTW_followRow",
  "grid": "ImvHTW_grid",
  "hideName": "ImvHTW_hideName",
  "hideTooltip": "ImvHTW_hideTooltip",
  "highlighted": "ImvHTW_highlighted",
  "hoverableName": "ImvHTW_hoverableName",
  "newsChip": "ImvHTW_newsChip",
  "profileContainer": "ImvHTW_profileContainer",
  "profileImage": "ImvHTW_profileImage",
  "tagsContainer": "ImvHTW_tagsContainer",
  "tagsDesc": "ImvHTW_tagsDesc",
  "tagsMob": "ImvHTW_tagsMob",
  "teamDesc": "ImvHTW_teamDesc",
  "teamDetail": "ImvHTW_teamDetail",
  "teamName": "ImvHTW_teamName",
  "tooltip": "ImvHTW_tooltip",
});
